const HacksterLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
  >
    <defs>
      <clipPath>
        <rect
          data-name="Rectangle 1"
          width="24"
          height="24"
          fill="currentColor"
        />
      </clipPath>
    </defs>
    <g data-name="Group 1831" transform="translate(-936 -219)">
      <rect
        data-name="Rectangle 1591"
        width="36"
        height="36"
        rx="5"
        transform="translate(936 219)"
        fill="currentColor"
      />
      <g data-name="Group 1468" transform="translate(942 225)">
        <g
          data-name="Group 1"
          transform="translate(0 0)"
          clipPath="url(#clip-path)"
        >
          <path
            data-name="Path 1"
            d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0m1.643,6.872a.392.392,0,0,1,.273-.358l1.953-.533a.2.2,0,0,1,.273.208V9.948a.283.283,0,0,1-.283.283H13.927a.283.283,0,0,1-.283-.283ZM7.835,8.459A.391.391,0,0,1,8.108,8.1l1.952-.533a.2.2,0,0,1,.273.208V8.5a.283.283,0,0,1-.282.283H8.118A.283.283,0,0,1,7.835,8.5Zm2.5,8.708a.391.391,0,0,1-.273.357l-1.953.534a.2.2,0,0,1-.273-.208V14.092a.283.283,0,0,1,.283-.283H10.05a.283.283,0,0,1,.283.283Zm5.809-1.587a.391.391,0,0,1-.273.357l-1.953.533a.2.2,0,0,1-.273-.208v-.729a.283.283,0,0,1,.282-.284H15.86a.283.283,0,0,1,.283.284Zm2.948-2.286a1.5,1.5,0,0,1-.4.132l-4.777,1.306a.2.2,0,0,1-.273-.208V13.29a.282.282,0,0,0-.282-.283H8.117a.282.282,0,0,1-.282-.282V11.29a.283.283,0,0,0-.283-.283H5.035a.179.179,0,0,1-.18-.178.165.165,0,0,1,.055-.125,1.415,1.415,0,0,1,.4-.134l4.758-1.3a.2.2,0,0,1,.272.208v1.247a.283.283,0,0,0,.283.282H15.86a.283.283,0,0,1,.283.283v1.421a.283.283,0,0,0,.282.283h2.541a.179.179,0,0,1,.179.179.158.158,0,0,1-.055.121"
            transform="translate(0 0)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default HacksterLogo;
